// @ts-nocheck
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { isServerBackedAnalysisId } from '../../../utils/isServerBackedAnalysisId';
import { RunSnapshotView } from '../runHistory';
import { Button } from '../components/WorkflowFormPrimitives';

export default function RunSnapshotPage() {
  const { analysisId, runId, companyId } = useParams();
  const navigate = useNavigate();
  const aid = String(analysisId ?? '').trim();
  const rid = String(runId ?? '').trim();
  const firmCompanyBack = String(companyId ?? '').trim();
  const backHref = firmCompanyBack ? `/firm/companies/${encodeURIComponent(firmCompanyBack)}` : '/client/run-history';
  const backLabel = firmCompanyBack ? 'Back to company' : 'Back to run history';

  return (
    <RunSnapshotView
      analysisId={aid}
      runId={rid}
      headerAction={
        isServerBackedAnalysisId(aid) && isServerBackedAnalysisId(rid) ? (
          <Button
            variant="secondary"
            size="sm"
            type="button"
            onClick={() => navigate(backHref)}
            className="inline-flex items-center gap-1.5"
          >
            <ArrowLeft size={14} /> {backLabel}
          </Button>
        ) : null
      }
    />
  );
}
